import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

// Fixed toasts anchored to the bottom of the viewport on mobile, where the
// alerts up in the navbar are easy to miss (the sticky nav doesn't stay in
// view). Desktop keeps using the navbar alerts, so this hides at md+.
const AlertToast = ({ alerts }) => {
    if (!alerts || alerts.length === 0) return null;
    return (
        <Box
            sx={{
                display: { xs: 'flex', md: 'none' },
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
                zIndex: (theme) => theme.zIndex.snackbar,
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                px: 2,
                pointerEvents: 'none',
            }}
        >
            {alerts.map((alert) => (
                <Box
                    key={alert.id}
                    className={`alert alert-${alert.alertType}`}
                    sx={{
                        borderRadius: '6px',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.45)',
                        width: '100%',
                        maxWidth: 480,
                        textAlign: 'center',
                        pointerEvents: 'auto',
                        animation: 'plToastIn 0.25s ease-out',
                        '@keyframes plToastIn': {
                            from: {
                                opacity: 0,
                                transform: 'translateY(12px)',
                            },
                            to: {
                                opacity: 1,
                                transform: 'translateY(0)',
                            },
                        },
                    }}
                >
                    {alert.msg}
                </Box>
            ))}
        </Box>
    );
};

AlertToast.propTypes = {
    alerts: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
    alerts: state.alert,
});

export default connect(mapStateToProps)(AlertToast);
